enum SeasonRoutes {
  List = '/seasons',
  Edit = '/seasons/edit/:id',
  Add = '/seasons/add',
}

export default SeasonRoutes
